import React, { Component } from "react";
import "./style.scss";
import classNames from "classnames";

export default class OpenPositions extends Component {
  createDots = () => {
    let dots = [];
    let { pagination, onDotClicked } = this.props;
    // Outer loop to create parent
    for (let i = 0; i < pagination.numberOfPages; i++) {
      let dotClasses = classNames("dot", {
        current: pagination.currentPage === i
      });
      dots.push(<span key={i} className={dotClasses} onClick={onDotClicked} id={i} />);
    }
    return dots;
  };

  render() {
    // if(!this.props.fields) return null;
    let { pagination, onClickedBack, onClickedForward } = this.props;
    let hideClassBack = classNames("pagination-button", "back", {
      hidden: pagination.currentPage === 0
    });
    let hideClassForward = classNames("pagination-button", "forward", {
      hidden: pagination.currentPage + 1 === pagination.numberOfPages
    });
    return (
      <div className={"pagination"}>
        {/* <span className={hideClassBack} onClick={onClickedBack}>
         <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24"><path d="M0 0h24v24H0V0z" fill="none" /><path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z" /></svg>
        </span> */}

        {this.createDots()}

        {/* <span className={hideClassForward} onClick={onClickedForward}>
          <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24"><path d="M0 0h24v24H0V0z" fill="none" /><path d="M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8-8-8z" /></svg>
        </span> */}
      </div>
    );
  }
}
